'use strict';

angular.module('msWidgets').directive('msAudioPlayer', ['$timeout', '$log', '$translate', function ($timeout, $log, $translate) {
  return {
    restrict: 'EA',
    templateUrl: 'widgets/templates/media/audio_player.html',
    link: function link(scope, element, attr) {
      scope.visualizer = attr.msVisualizer;

      var colorScheme = {
        playPauseIcon: '#008cba',
        progressArc: '#008cba',
        progressArcShadow: '#bfe2ed',
        blobColor: '#bfe2ed'
      };
      $timeout(function () {
        scope.activityAudio = element[0].querySelector('audio');
        scope.activityAudio.progress = document.querySelector('progress');
        scope.activityAudio.remainingTime = 0;
        scope.activityAudio.addEventListener('ended', function () {
          scope.pause();
        });
        scope.activityAudio.addEventListener('canplay', function () {
          scope.activityAudio.remaining = scope.activityAudio.duration;
          updateTimeRemaining();
        });
        // Autoplay the audio
        if (attr.msAutoplay === 'true') {
          scope.$watch('activityAudio.canPlay', function () {
            $log.debug('autoplaying.....?');
            if (scope.activityAudio && scope.activityAudio.canPlay) {
              $log.debug('autoplaying!');
              scope.play();
            }
          });
        }

        scope.activityAudio.addEventListener("timeupdate", function () {
          var value = 0;
          if (scope.activityAudio.currentTime > 0) {
            value = scope.activityAudio.currentTime / scope.activityAudio.duration;
          }
          if (scope.activityAudio.duration - scope.activityAudio.currentTime <= 0) {
            scope.pause();
          }
          scope.activityAudio.progress.value = value;
          updateTimeRemaining();
          scope.$apply();
        }, false);

        // I am not proud of this
        $timeout(function () {
          if (scope.activityAudio.progress) {
            scope.activityAudio.scrubber = document.querySelector('input.audio-control');
            scope.activityAudio.scrubber.addEventListener('mouseup', function () {
              scope.activityAudio.currentTime = parseFloat(scope.activityAudio.progress.value * scope.activityAudio.duration);
            });
            scope.activityAudio.progress.value = 0;
            scope.$apply();
          }
        });
      });
      scope.isPlaying = false;

      setPlayPauseString(scope.isPlaying);

      function setPlayPauseString(isPlaying) {
        var stringChoice = isPlaying ? 'activities.widgets.mediaControls.pause' : 'activities.widgets.mediaControls.play';
        $translate(stringChoice).then(function (translatedString) {
          scope.playPauseButtonLabel = translatedString;
        });
      }

      scope.play = function () {
        scope.activityAudio.play();
        scope.isPlaying = true;

        if (attr.msVisualizer === 'true') {
          // Start the Two.js animations. Don't forget to pause these later!
          // Unlike pausing, we need to start Two.js before anything else happens.
          two.play();
          animateToPause();
        }
      };

      scope.pause = function () {
        scope.activityAudio.pause();
        scope.isPlaying = false;

        if (attr.msVisualizer === 'true') {
          // Unlike playing, we need to pause the animations in `onComplete` with Tween.
          // Otherwise the Play/Pause morph animation won't render.
          animateToPlay();
        }
      };

      scope.togglePlayback = function () {
        if (scope.isPlaying) {
          scope.pause();
        } else {
          scope.play();
        }
        setPlayPauseString(scope.isPlaying);
      };

      scope.jumpBack = function (jumpTime) {
        scope.activityAudio.currentTime = scope.activityAudio.currentTime - jumpTime;
      };

      function updateTimeRemaining() {
        if (scope.activityAudio.duration >= 0) {
          scope.activityAudio.remaining = scope.activityAudio.duration - scope.activityAudio.currentTime;
          var seconds = parseInt(scope.activityAudio.remaining % 60);
          var minutes = parseInt(scope.activityAudio.remaining / 60 % 60);
          if (minutes < 10) {
            minutes = '0' + minutes;
          }
          if (seconds < 10) {
            seconds = '0' + seconds;
          }
          scope.activityAudio.remainingTime = minutes + ':' + seconds;
        }
      }

      var animateToPause = function animateToPause() {

        var morphTweensLarge = [];
        var morphTweensSmall = [];

        // We need to make some centering adjustments because the two icons are different widths.

        largeEnd.vertices.forEach(function (vertex, i) {
          morphTweensLarge[i] = new TWEEN.Tween(largeEnd.vertices[i]).to({
            x: pause1.vertices[i].x - 5,
            y: pause1.vertices[i].y
          }, 500).easing(TWEEN.Easing.Quartic.Out);
          morphTweensLarge[i].start();
        });

        smallPoint.vertices.forEach(function (vertex, i) {
          morphTweensSmall[i] = new TWEEN.Tween(smallPoint.vertices[i]).to({
            x: pause2.vertices[i].x - 5,
            y: pause2.vertices[i].y
          }, 500).easing(TWEEN.Easing.Quartic.Out);
          morphTweensSmall[i].start();
        });
      };

      var animateToPlay = function animateToPlay() {

        // It shouldn't ever not be playing at this point, but let's jsut be certain.
        if (!two.playing) {
          two.play();
        }

        var morphTweensLarge = [];
        var morphTweensSmall = [];

        largeEnd.vertices.forEach(function (vertex, i) {
          morphTweensLarge[i] = new TWEEN.Tween(largeEnd.vertices[i]).to({
            x: largeEndAnchors[i].x,
            y: largeEndAnchors[i].y
          }, 500).easing(TWEEN.Easing.Quartic.Out);
          morphTweensLarge[i].start();
        });

        smallPoint.vertices.forEach(function (vertex, i) {
          morphTweensSmall[i] = new TWEEN.Tween(smallPoint.vertices[i]).to({
            x: smallPointAnchors[i].x,
            y: smallPointAnchors[i].y
          }, 500).easing(TWEEN.Easing.Quartic.Out).onComplete(function () {
            // Make sure to pause Two.js animations when not needed, but not before.
            // Also, only pause if there are no other Tweens running, or you get graphical glitches.
            if (i === 3 && two.playing && TWEEN.getAll().length <= 1) {
              two.pause();
            }
          });
          morphTweensSmall[i].start();
        });
      };

      var two, playIcon;
      $timeout(function () {
        if (attr.msVisualizer === 'true') {
          createScene();
          drawArcs();
          drawPlayIcon();
          two.update();

          //   This gets run on every frame ~60fps
          two.bind('update', function () {
            progressArcShadow.fill = colorScheme.progressArc;

            two.remove(progressArc);
            progressArc = two.makeArcSegment(centerX, centerY, progressArcSize, progressArcSize - progressArcWeight, 0, Math.PI * 2 - Math.PI * 2 * (scope.activityAudio.currentTime / scope.activityAudio.duration));
            progressArc.fill = colorScheme.progressArcShadow;
            progressArc.stroke = colorScheme.progressArcShadow;
            progressArc.rotation = Math.PI;

            // I got better performance by putting this at the end.
            TWEEN.update();
          });
        }
      });

      //   Useful Variables
      var centerX;
      var centerY;

      //   Progress Arc
      var progressArcSize = 80;
      var progressArcWeight = 10;

      // Icon Size
      var playIconSize = 32;

      function createScene() {
        var isCanvasSupported = function isCanvasSupported() {
          var elem = document.createElement('canvas');
          return !!(elem.getContext && elem.getContext('2d'));
        };
        var type = isCanvasSupported() ? 'canvas' : 'svg';
        two = new Two({
          type: Two.Types[type],
          fullscreen: false,
          width: 280,
          height: 280,
          autostart: false
        }).appendTo(document.querySelector('#stage'));

        //   Useful Variables
        centerX = two.width / 2;
        centerY = two.height / 2;
      }

      //   Just a bunch of variables used when splitting.
      // *_Anchors save the original vertex locations along the Play Icon
      var pause1, pause2, pauseIcon, smallPoint, largeEnd, smallPointAnchors, largeEndAnchors;

      function splitLine() {

        var width = playIcon.getBoundingClientRect(true).width;
        var height = playIcon.getBoundingClientRect(true).height;

        var leftSide = playIcon.getBoundingClientRect(true).left;
        var rightSide = playIcon.getBoundingClientRect(true).right;
        var topSide = playIcon.getBoundingClientRect(true).top;
        var bottomSide = playIcon.getBoundingClientRect(true).bottom;

        var relativeCenterX = leftSide + width / 2;
        // var absoluteCenterX = playIconSize + (two.width / 2);

        var bottomSegmentY = bottomSide - height / 4;
        var topSegmentY = topSide + height / 4;

        smallPoint = two.makePath(relativeCenterX, topSegmentY, rightSide, bottomSide - height / 2, rightSide, bottomSide - height / 2, relativeCenterX, bottomSegmentY, true);
        smallPoint.noStroke().fill = colorScheme.playPauseIcon;
        smallPointAnchors = angular.copy(smallPoint.vertices);

        largeEnd = two.makePath(leftSide, topSide, relativeCenterX, topSegmentY, relativeCenterX, bottomSegmentY, leftSide, bottomSide, true);
        largeEnd.noStroke().fill = colorScheme.playPauseIcon;
        largeEndAnchors = angular.copy(largeEnd.vertices);

        pause1 = two.makePath(relativeCenterX - playIconSize, topSide, relativeCenterX - 15, topSide, relativeCenterX - 15, bottomSide, relativeCenterX - playIconSize, bottomSide, true);

        pause2 = two.makePath(relativeCenterX + 15, topSide, relativeCenterX + playIconSize, topSide, relativeCenterX + playIconSize, bottomSide, relativeCenterX + 15, bottomSide, true);
        pauseIcon = two.makeGroup(pause1, pause2);
        pauseIcon.visible = false;

        // Just group these to bring them up to the top layer.
        two.makeGroup(largeEnd, smallPoint);

        two.update();
      }

      var progressArc, progressArcShadow, progressFill;

      function drawArcs() {

        progressArcShadow = two.makeArcSegment(centerX, centerY, progressArcSize, progressArcSize - progressArcWeight, 0, Math.PI * 2 * 1.0);
        progressArcShadow.noStroke().fill = colorScheme.progressArcShadow;

        progressArc = two.makeArcSegment(centerX, centerY, progressArcSize, progressArcSize - progressArcWeight, 0, Math.PI * 2 * 0);
        progressArc.visible = false;

        progressFill = two.makeCircle(centerX, centerY, progressArcSize - progressArcWeight);
        progressFill.noStroke().fill = '#fff';

        //  Group this stuff to display it on the top layer.
        two.makeGroup(progressArcShadow);
      }

      function drawPlayIcon() {

        // Create Hidden Play Triangle Icon (only used to get Anchor Coordinates)
        playIcon = two.makePolygon(centerX, centerY, playIconSize, 3);
        playIcon.visible = false;
        playIcon.rotation = 2 * Math.PI * 0.25;

        splitLine();
      }
    }

  };
}]);